import { useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

const ImagePreview = ({ isOpen, onClose, images,  }) => {
//   const [currentIndex, setCurrentIndex] = useState(selectedIndex || 0);

//   const nextImage = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//   };

//   const prevImage = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
//   };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="slider-main">
        <button className="close" onClick={onClose}>
          <img src="https://admin.abroadbible.net/assets/images/Close_round_light.svg" alt="close" />
        </button>
        <div className="slider-main">
        <img src={images} />
        </div>
        {/* <div className="btns">
          <button onClick={prevImage} className="pre">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <button onClick={nextImage} className="next">
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
         */}
      </div>
    </div>
  );
}


export default ImagePreview;
